import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [stockCount, setStockCount] = useState(2847);
  // Eliminados: isAuthenticated, userProfile (ya no se usan)
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Simulate stock updates
    const interval = setInterval(() => {
      setStockCount(prev => Math.max(0, prev - Math.floor(Math.random() * 3)));
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  // Eliminado: "Mi Perfil" y "Contacto" del array de navegación
  const navigationItems = [
    { label: 'Inicio', path: '/home-landing', icon: 'Home' },
    { label: 'Comprar Boletos', path: '/purchase-flow', icon: 'Ticket' },
    { label: 'Verificar Boletos', path: '/ticket-verification', icon: 'Search' },
    // { label: 'Contacto', path: '/contact', icon: 'MessageCircle' } // <-- Eliminado
  ];

  const isActiveRoute = (path) => {
    return location?.pathname === path;
  };

  // Eliminada: función handleAuthAction (ya no se usa)

  return (
    <header className={`fixed top-0 left-0 right-0 z-100 transition-all duration-300 ${
      isScrolled ? 'bg-background/95 backdrop-blur-md shadow-luxury' : 'bg-background'
    }`}>
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-16 px-4 lg:px-6">
          {/* Logo */}
          <Link to="/home-landing" className="flex items-center space-x-3 hover:opacity-80 transition-premium">
            <div className="w-10 h-10 bg-gradient-to-br from-secondary to-golden rounded-lg flex items-center justify-center shadow-golden">
              <span className="text-navy font-heading font-bold text-xl">ÁF</span>
            </div>
            <div className="hidden sm:block">
              <h1 className="text-xl font-heading font-bold text-foreground">Áurea Fortuna</h1>
              <p className="text-xs text-text-secondary font-caption">Lotería Premium</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navigationItems?.slice(0, 3)?.map((item) => ( // Cambiado de 4 a 3
              <Link
                key={item?.path}
                to={item?.path}
                className={`px-4 py-2 rounded-lg font-body font-medium text-sm transition-premium flex items-center space-x-2 ${
                  isActiveRoute(item?.path)
                    ? 'bg-secondary text-secondary-foreground shadow-golden'
                    : 'text-text-secondary hover:text-foreground hover:bg-muted/50'
                }`}
              >
                <Icon name={item?.icon} size={16} />
                <span>{item?.label}</span>
              </Link>
            ))}
          </nav>

          {/* Stock Counter & User Actions */}
          <div className="flex items-center space-x-4">
           

            {/* Eliminado: Contenido de autenticación (Iniciar Sesión, Mi Perfil, Cerrar Sesión) */}
            <div className="hidden lg:flex items-center space-x-3">
              {/* Aquí ya no va nada */}
            </div>

            {/* Mobile Menu Button */}
            <Button
              variant="ghost"
              size="icon"
              className="lg:hidden"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <Icon name={isMenuOpen ? "X" : "Menu"} size={20} />
            </Button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden bg-background border-t border-border animate-slide-in-from-top">
            <div className="px-4 py-4 space-y-2">
              {/* Stock Counter Mobile */}
              <div className="flex items-center justify-center space-x-2 px-3 py-2 bg-muted/30 rounded-lg border border-golden/20 mb-4">
                <Icon name="Clock" size={16} className="text-secondary" />
                <span className="font-mono text-foreground">{stockCount?.toLocaleString()}</span>
                <span className="text-sm text-text-secondary font-caption">boletos disponibles</span>
              </div>

              {/* Navigation Items */}
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={() => setIsMenuOpen(false)}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg font-body font-medium transition-premium ${
                    isActiveRoute(item?.path)
                      ? 'bg-secondary text-secondary-foreground shadow-golden'
                      : 'text-text-secondary hover:text-foreground hover:bg-muted/50'
                  }`}
                >
                  <Icon name={item?.icon} size={18} />
                  <span>{item?.label}</span>
                </Link>
              ))}

              {/* Eliminado: Contenido de autenticación móvil (Iniciar Sesión, Mi Perfil, Cerrar Sesión) */}
              {/* Aquí ya no va nada */}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;